export default __webpack_public_path__ + "static/media/cardio.a42c4bc2.svg";